import type { PublishTarget } from "@coinfallsmp/shared";

const PLATFORM_LABELS: Record<PublishTarget["platform"], string> = {
  website: "Website (media.coinfallsmp.net)",
  tiktok: "TikTok",
  instagram: "Instagram",
};

export default function PublishTargetsPanel({
  targets,
}: {
  targets: PublishTarget[];
}) {
  return (
    <div className="publish-targets">
      <h2>Publish targets</h2>
      {targets.map((target) => (
        <div key={target.id} className="publish-target-row">
          <div>
            <strong>{PLATFORM_LABELS[target.platform]}</strong>
            <div className="publish-target-status">
              <span className={`status-badge status-${target.status}`}>
                {target.status.replace("_", " ")}
              </span>
              {target.externalUrl ? (
                <a href={target.externalUrl} target="_blank" rel="noreferrer">
                  View
                </a>
              ) : null}
            </div>
            {target.errorMessage ? (
              <p className="form-error">{target.errorMessage}</p>
            ) : null}
          </div>
          {target.platform !== "website" ? (
            <button className="button secondary" disabled title="Requires TikTok/Meta developer app approval">
              Coming soon
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
